"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiCircularProgressOverrides = void 0;
var createMuiCircularProgressOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        svg: {
            // Default size is 40x40px and stroke is 4px. So: (40 / 2 - 4) / (40 / 2) = 0.8 (80%)
            backgroundImage: "radial-gradient(circle closest-side, transparent 80%, " + palette.divider + " 80%, " + palette.divider + " 100%, transparent 100%)",
            "$indeterminate &": {
                backgroundImage: "unset",
            },
        },
        colorSecondary: {
            color: palette.secondary.main,
        },
    });
};
exports.createMuiCircularProgressOverrides = createMuiCircularProgressOverrides;
//# sourceMappingURL=MuiCircularProgress.js.map